import React, { ReactElement } from 'react';
import Widget from '../../../../components/widget/widget.component';
import VisualEditorSectionBlock
  from '../../../../components/visual-editor-section-block/visual-editor-section-block.component';
import SinglePageTab from '../../../app/common/single-page-tab/single-page-tab.component';

const DealTemplateSchedule: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isActive,
    isRightDrawerOpen,
    formError,
    onCancelForm,
    onSubmitForm,
  } = props;

  return (
    <SinglePageTab
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isHidden={!isActive}
      isRightDrawerOpen={isRightDrawerOpen}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      <Widget isFullHeight isFullWidth defaultWidgetTitle="Schedule Gantt Chart">
        <VisualEditorSectionBlock isDisabled withNoEdit isEditMode={isEditMode} />
      </Widget>
    </SinglePageTab>
  );
});

export default DealTemplateSchedule;
